import { lazy, Suspense } from 'react';

import { NoSSR } from '@xing-com/crate-utils-no-ssr';

import type { LikersListProps } from '../likers-list/likers-list';

const LikersListComponent = lazy(() => {
  return import('../likers-list/likers-list').then((module) => ({
    default: module.LikersList,
  }));
});

export const LazyLikersList: React.FC<LikersListProps> = (props) => {
  return (
    <NoSSR>
      <Suspense>
        <LikersListComponent {...props} />
      </Suspense>
    </NoSSR>
  );
};
